const initials = "blogs/";
export const UPDATE_BLOGS = `${initials}UPDATE_BLOGS`;
